// @flow
import Utils from './Utils'
import ErrorManager from './ErrorManager'
import MainConnector from './MainConnector'

/**
 *
 * TD3.X transactions management
 * @class ConsultationConnector
 * @extends {MainConnector}
 */
class SearchConnector extends MainConnector {
    documents: any

    /**
     * @description Default constructor
     * @param {boolean} verbose = if true verbose
     * @param {boolean} testEnv = if true test env (eg. not real life DMP)
     */
    constructor(verbose: boolean = false, testEnv: boolean = false) {
        super(verbose, testEnv)
        this.documents = []
    }

    /**
     * @async
     * @description Get document by id with insWithType and documentUniqueId parameters to the DMP for a patient
     * @param {*} insWithType
     * @param {*} documentUniqueId
     * @returns
     */
    async getDocumentById(insWithType: string, documentUniqueId: string): Promise<any> {
        const requestEndPoint = 'getDocumentUuidByUniqueId'
        if (!Utils.checkNirOrInsIsValid(insWithType)) {
            ErrorManager.sendError('invalid ins format should be string of 15 or 16 length (source - sendDocuments)')
        }
        const extraEndPointParams = {
            s_ins: insWithType,
            s_documentUniqueId: documentUniqueId,
        }
        const result = await this.makeRequest(requestEndPoint, extraEndPointParams)
        return result
    }

    /**
     * @async
     * @description Destroy document with insWithType, documentUniqueId and healthcareSetting parameters to the DMP for a patient
     * @param {string} insWithType
     * @param {string} documentUniqueId
     * @param {string} healthcareSetting  defaults to '60' which maps to 'consultation and act'. Context of doc sending (see main doc for ref)
     * @returns
     */
    async deleteDocument(
        insWithType: string,
        documentUniqueId: string,
        healthcareSetting: string = '60',
    ): Promise<any> {
        const requestEndPoint = 'deleteDocument'
        if (!Utils.checkNirOrInsIsValid(insWithType)) {
            ErrorManager.sendError('invalid ins format should be string of 15 or 16 length (source - sendDocuments)')
        }
        const extraEndPointParams = {
            s_ins: insWithType,
            s_documentUniqueId: documentUniqueId,
            s_healthcareSetting: healthcareSetting,
        }
        const result = await this.makeRequest(requestEndPoint, extraEndPointParams)
        return result
    }
}

export default SearchConnector
